import io from 'socket.io-client';
var socket = null;
var createSocket = function () {
    var options = {
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        timeout: 20000,
        transports: ['websocket', 'polling'],
        forceNew: false,
    };
    socket = io('https://service.ego.ru.net', options);
    // socket = io('http://localhost:3000', options);
    socket.on('connect', function () {
        console.log('[Socket] Connected successfully');
    });
    socket.on('disconnect', function (reason) {
        console.warn('[Socket] Disconnected:', reason);
    });
    socket.on('connect_error', function (error) {
        console.error('[Socket] Connection error:', error);
    });
    socket.on('reconnect', function (attemptNumber) {
        console.log("[Socket] Reconnected after ".concat(attemptNumber, " attempts"));
    });
    return socket;
};
export var getSocket = function () {
    if (!socket) {
        socket = createSocket();
    }
    else if (!socket.connected) {
        // If socket exists but not connected, try to reconnect
        socket.connect();
    }
    return socket;
};
export var disconnectSocket = function () {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
};
export var isSocketConnected = function () {
    return (socket === null || socket === void 0 ? void 0 : socket.connected) || false;
};
export default getSocket;
